import { Download } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Dialog, DialogTitle, Stack, Typography } from "@mui/material";
import { useState } from "react";
import API from "../../../../services/API";

export default function DocumentsModal({session, onClose}){

    const [loading, setLoading] = useState(null) 

    const handleClick = doc => {

        setLoading(doc.title)

        API.download(doc.endpoint.replace(':id', session?.id))
            .catch(e => console.log(e))
            .finally(() => setLoading(null))

    }

    return (
        <Dialog onClose={onClose} open={session ? true : false}>

            <DialogTitle>Session {session?.number}</DialogTitle>

            <Stack sx={{minWidth: 300}}>

                {docs.map(doc => 
                    <Stack 
                        key={doc.title} 
                        direction="row" 
                        spacing={2} 
                        alignItems="center"
                        onClick={() => handleClick(doc)}
                        sx={{p: 1}}
                    >

                        <LoadingButton
                            loading={loading === doc.title}
                        >
                            <Download />
                        </LoadingButton>
                            
                        <Typography color="text.secondary" variant="body2">
                            {doc.title}
                        </Typography>

                    </Stack>    
                )}

            </Stack>

        </Dialog>
    )
}

const docs = [
    {title: 'Participations ZIP', endpoint: "/dpc/sessions/:id/participation.zip"},
    {title: 'Logs', endpoint: "/dpc/sessions/:id/logs.html"},
    {title: 'Traçabilité', endpoint: "/dpc/sessions/:id/traceability.csv"},
];